import axios from 'axios';
/* export const baseURL = 'https://testapi.ccr.land'; */
export const baseURL = 'https://mainapi.ccr.land';
import { ElMessage } from "element-plus"
import { res } from 'pino-std-serializers';

// 创建 Axios 实例
const https = axios.create({
  baseURL: baseURL, // 设置基础 URL
  timeout: 20000, // 设置请求超时时间
});

// 请求拦截器
https.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 例如，添加 token 到请求头
    const user = localStorage.getItem('flst:user') ? JSON.parse(localStorage.getItem('flst:user')) : null;
    if (user) {
      config.headers["token"] = `${user.token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
https.interceptors.response.use((response) => {
  if(response.data.code === 0){
    ElMessage.error(response.data.msg)
  }
  // if (response.data.data === 401) {
  //   ElMessage.error("请先连接钱包")
  // }
  return response.data;
  // 对响应数据做些什么
}, (error) => {
  console.log(error, "errorerrorerrorerrorerror");
  // 对响应错误做些什么
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 处理未授权的情况
        break;
      case 404:
        // 处理未找到资源的情况
        break;
      // 其他状态码处理
      default:
        console.error('请求错误:', error.response.status);
    }
  }
  return Promise.reject(error);
}
);

export default https;